export default "__VITE_ASSET__CI5DSIB3__"